import type { ParagraphDarkTextMiniCards as ParagraphDarkTextMiniCardsData } from "@/lib/api/cms-catalog";
import type { ParagraphTranslations } from "../Paragraph.i18n";
import styles from "./ParagraphDarkTextMiniCards.module.css";

/**
 * Layout 51 - `PARAGRAPH_DARK_TEXT_MINI_CARDS_LAYOUT`: dark text + mini cards.
 *
 * Struktura:
 *   - Dark full-bleed bg (--color-chrome-dark)
 *   - 2 kolumny:
 *     - Lewa: image (np. flaga) + eyebrow (text_1) + big H2 (name)
 *     - Prawa: grid 2x2 kart z ikonami + nazwa + krotki opis
 *
 * Analog PARAGRAPH_TEXT_MINI_CARDS_LAYOUT (46) w wariancie dark, bez lead/CTA.
 * Typowo: "Tworzony w Polsce" / feature highlights.
 */
export function ParagraphDarkTextMiniCards({
  paragraph,
  t: _t,
}: {
  paragraph: ParagraphDarkTextMiniCardsData;
  t: ParagraphTranslations;
}) {
  const { image, text_1: eyebrow, name: title, items } = paragraph;

  const hasEyebrow = eyebrow && eyebrow.trim() !== "";
  const hasImage = !!image;

  return (
    <section className={styles.section}>
      <div className={styles.grid}>
        <div className={styles.header}>
          {hasImage ? (
            <img src={image} alt="" className={styles.headerImage} loading="lazy" />
          ) : null}
          <div className={styles.headerText}>
            {hasEyebrow ? <span className={styles.eyebrow}>{eyebrow}</span> : null}
            {title ? <h2 className={styles.title}>{title}</h2> : null}
          </div>
        </div>

        {items.length > 0 ? (
          <ul className={styles.cards}>
            {items.map((item, idx) => (
              <li key={idx} className={styles.card}>
                {item.icon ? (
                  <i
                    className={`${styles.cardIcon} nc-icon-outline ${item.icon}`}
                    aria-hidden="true"
                  />
                ) : null}
                <div className={styles.cardBody}>
                  {item.name ? <h3 className={styles.cardTitle}>{item.name}</h3> : null}
                  {item.desc ? <p className={styles.cardDesc}>{item.desc}</p> : null}
                </div>
              </li>
            ))}
          </ul>
        ) : null}
      </div>
    </section>
  );
}
